import React from "react";
import axios from "axios";
import { useEffect } from "react";

import BallotComponent from "../components/BallotComponent";
import { BallotContext } from "../context/BallotContext";
import BallotInterface from "../interfaces/ballotInterface";

export default function Dashboard() {

  useEffect(() => {
    document.title = "DxD Dashboard";
  }, []);

  const [ballots, setBallots] = React.useState<any[]>([]);
  const fetchUsers = async () => {
    const response = await axios.get(process.env.REACT_APP_HOST + "/mysecretkey/ballots");
    setBallots(response.data);
    console.log("Initial ballot ID: " + response.data[0].id);
    // console.log("B: " + ballots[0].id) -- reports undefined
  };

  // Need to update these regularly since Izzie can change them - similar to in Voting
  // For now we udpate this whenever the user interacts

  const [currentShowID, setCurrentShowID] = React.useState('');
  const fetchCurrentShowID = async () => {
    const response = await axios.get(process.env.REACT_APP_HOST + "/mysecretkey/getCurrentShowID");
    var cSID = response.data.id;
    setCurrentShowID(cSID);
  }

const [currentBallotID, setCurrentBallotID] = React.useState('not yet determined');
  const fetchCurrentBallotID = async () => {
    const response = await axios.get(process.env.REACT_APP_HOST + "/ballots/current");
    var cBID = response.data.id;
    setCurrentBallotID(cBID);
  }

  const [currentFadeState, setCurrentFadeState] = React.useState('');
  const fetchCurrentFadeState = async () => {
    const response = await axios.get(process.env.REACT_APP_HOST + "/mysecretkey/fadestate");
    var fs = response.data.fade;
    var fsString = (fs?"true":"false");
    console.log("fetchCurrentFadeState(): " + fsString);
    setCurrentFadeState(fsString);
  }


  /*
  React.useEffect(() => {
    fetchCurrentBallot();
  }, []);
  */

  React.useEffect(() => {
    fetchUsers();
    fetchCurrentBallotID();
    fetchCurrentFadeState();
    fetchCurrentShowID();
  }, []);
  
  const [showID, setShowID] = React.useState('');
  function handleShowIDChange(e) {
    setShowID(e.target.value);
    fetchCurrentBallotID();
    fetchCurrentFadeState();
    fetchCurrentShowID();
  }
  
  const setupNewShow = () => {
    axios
    .get(process.env.REACT_APP_HOST + "/mysecretkey/setupshow/" + showID)
    .then((response) => {
      console.log(response.data);
      fetchCurrentBallotID();
      fetchCurrentFadeState();
      fetchCurrentShowID();

    })
    .catch((ex) => {
      const error = "An unexpected error has occurred. Could not vote";
    });        

  }

  const cueThis = (p) => {
    axios
    .get(process.env.REACT_APP_HOST + "/mysecretkey/ballots/setCurrent/" + p.id)
    .then((response) => {
      console.log("cueThis()");
      // setCurrentBallotID(response.data.id)
      fetchCurrentBallotID();
      fetchCurrentFadeState();
      fetchCurrentShowID();
    })
    .catch((ex) => {
      const error = "An unexpected error has occurred. Could not vote";
    });        
  };

  const toggleFade = () => {
    axios
    .get(process.env.REACT_APP_HOST + "/mysecretkey/togglefadestate")
    .then((response) => {
      console.log(response.data);
      fetchCurrentBallotID();
      fetchCurrentFadeState();
      fetchCurrentShowID();

    })
    .catch((ex) => {
      const error = "An unexpected error has occurred. Could not vote";
    });        
  };

  const hideScreen = () => {
    axios
    .get(process.env.REACT_APP_HOST + "/mysecretkey/fadetrue")
    .then((response) => {
      console.log(response.data);
      fetchCurrentBallotID();
      fetchCurrentFadeState();
      fetchCurrentShowID();

    })
    .catch((ex) => {
      const error = "An unexpected error has occurred. Could not hide screen";
    });        
  };

  const showScreen = () => {
    axios
    .get(process.env.REACT_APP_HOST + "/mysecretkey/fadefalse")
    .then((response) => {
      console.log(response.data);
      fetchCurrentBallotID();
      fetchCurrentFadeState();
      fetchCurrentShowID();

    })
    .catch((ex) => {
      const error = "An unexpected error has occurred. Could not show screen";
    });        
  };

  const resetDB = () => {
    axios
    .get(process.env.REACT_APP_HOST + "/mysecretkey/resetdb")
    .then((response) => {
      console.log(response.data);
    })
    .catch((ex) => {
      const error = "An unexpected error has occurred. Could not vote";
    });        
  };

  const populateDB = () => {
    axios
    .get(process.env.REACT_APP_HOST + "/mysecretkey/populatedb")
    .then((response) => {
      console.log(response.data);
    })
    .catch((ex) => {
      const error = "An unexpected error has occurred. Could not vote";
    });        
  };

  const exportDB = () => {
    axios
    .get(process.env.REACT_APP_HOST + "/mysecretkey/export")
    .then((response) => {
      console.log(response.data);
    })
    .catch((ex) => {
      const error = "An unexpected error has occurred. Could not vote";
    });        
  };

  return (
    <div className="row">
      <div className="col-8">
        Show: {currentShowID}<br />
        Ballot: {currentBallotID}<br />
        Fade State: {currentFadeState}
      {ballots.map((p) => (
        <li key={p.id}>
        <p><button className="button is-green" onClick={() => cueThis(p)}>Cue</button> ({p.id}) {p.description} </p>            
        </li>
        ))}          
      </div>
      <div className="col-4">
        <h2>Back-end functions</h2>
        <form>
          <textarea rows={1} cols={8} value={showID} onChange={handleShowIDChange} />
        </form>
        <button className="button is-green" onClick={() => setupNewShow()}>Set up new show</button><br />
        <hr />
        <button className="button is-green" onClick={() => hideScreen()}>Hide Screen</button><br />
        <button className="button is-green" onClick={() => showScreen()}>Show Screen</button><br />
        <hr />
        <button className="button is-green" onClick={() => resetDB()}>Delete DB (use caution)</button><br />
        <button className="button is-green" onClick={() => populateDB()}>Populate DB (use caution)</button><br />
        <button className="button is-green" onClick={() => exportDB()}>Export DB to server (use caution)</button><br />
        <button className="button is-green" onClick={() => toggleFade()}>Toggle Fade State</button><br />
      </div>
    </div>
   );
}